import React from 'react';

export const TableHeader = () => (
    <thead className="kt-datatable__head">
        <tr className="kt-datatable__row">
        <th className="kt-datatable__cell" style={{ width: '150px' }}><span>Дата</span></th>
            <th className="kt-datatable__cell" style={{ width: '150px' }}><span>Телефон</span></th>
            <th className="kt-datatable__cell" style={{ width: '70px' }}><span>Источник</span></th>
            <th className="kt-datatable__cell" style={{ width: '70px' }}><span>Тип</span></th>
            <th className="kt-datatable__cell" style={{ width: '150px' }}><span>Филиал</span></th>
            <th className="kt-datatable__cell" style={{ width: '250px' }}><span>Адрес</span></th>
            <th className="kt-datatable__cell" style={{ width: 'auto' }}><span>Причины блокировки</span></th>
        </tr>
    </thead>
);